import script from "./ModalExportError.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalExportError.vue?vue&type=script&lang=ts&setup=true"

import "./ModalExportError.vue?vue&type=style&index=0&id=ea59e2a6&lang=scss"

const __exports__ = script;

export default __exports__